import { EcommerceCartItem } from '@jbhi-fi/utils/src/ga4Tracking/types';

export const transformProductGtmDataForTracking = (
  productGtmData: Record<string, any>,
  page: string,
  variantId?: number | string,
  variantFamilyName?: string,
  productGroupName?: string,
  ecommerceCartItemProps?: Partial<EcommerceCartItem>
): EcommerceCartItem => {
  const { name, id, price, brand, category } = productGtmData;
  const categories = category.split('/');

  let variantList;

  if (variantFamilyName && productGroupName) {
    variantList = `${productGroupName} ${variantFamilyName} variants`;
  }

  const item: EcommerceCartItem = {
    discount: 0,
    item_bestseller_flag: 'unavailable',
    item_brand: brand,
    item_category: categories[0],
    item_category2: categories[1],
    item_category3: categories[2],
    item_category4: categories[3],
    item_id: id,
    item_list_name: variantList || page,
    item_name: name,
    item_review_count: 'unavailable',
    item_review_score: 'unavailable',
    item_variant: variantId?.toString() || id,
    price: price,
    quantity: 1,
    ...ecommerceCartItemProps,
  };

  return item;
};
